import React, { Component } from 'react';
import PropTypes from 'prop-types';
import compose from 'lodash/flowRight';
import { connect } from 'react-redux';
import { getLang } from 'redux-pagan';
import get from 'lodash/get';
import { asyncConnect } from 'redux-connect';
import { reset as resetReduxForm } from 'redux-form';
import Company from '../../components/Company/Company';
import { extractRouteData } from '../../helpers/routerAdapter';
import {
  loadCompany,
  loadCompanyProps,
  openCompanyContactModal,
  closeCompanyContactModal,
  sendCompanyContactUsForm,
  reset,
  translateDescription,
  translateAdditionalInfo,
  detectDescriptionLanguage,
  detectAdditionalInfoLanguage,
  toggleDescriptionTranslation,
  toggleAdditionalInfoTranslation,
  resetTranslate,
  loadOwnCompany
} from '../../redux/modules/company';
import { consultationReset, sendConsultationForm } from '../../redux/modules/consultation';
import { openModalShare, hideModalShare } from '../../redux/modules/shareModal';
import { hideMessageModal, openMessageModal } from '../../redux/modules/messageModal';
import {
  changeLightboxActiveSlide,
  hideLightbox,
  openLightbox
} from '../../redux/modules/propertyDetails';
import { setPinAsReviewed } from '../../redux/modules/reviewedPins';
import { loadFavorites, toggleFavorite } from '../../redux/modules/favoriteProperties';
import appendLocale from '../../helpers/appendLocale';
import { ENTITY_TYPES } from '../../constants';
import withDetailsPopupPage from '../../containers/DetailsPopupContainer/DetailsPopupPageWrapper';
import withPageWrapper from '../../containers/PageContainer/PageContainer';

class CompanyPage extends Component {
  state = {
    showMessageModal: false
  };

  componentWillMount() {
    if (this.props.error && this.props.error.status === 404) {
      this.context.router.replace(appendLocale(this.props.locale, '/professionals'));
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.error && nextProps.error.status === 404 && !this.props.error) {
      this.context.router.replace(appendLocale(this.props.locale, '/professionals'));
    }
  }

  componentWillUnmount() {
    this.props.reset();
    this.props.consultationReset();
  }

  openDetailsPopup = ({ propertyId, slug }) =>
    this.props.openPopupWithDetails(null, slug || propertyId, ENTITY_TYPES.PROPERTY, { slug, propertyId });

  render() {
    const {
      isNative,
      companyDetails: {
      translatedDescriptionRequired,
      descriptionLoaded,
      translatedDescriptionText,
      showOriginalDescription,
      descriptionLoading,
      translatedAdditionalInfoRequired,
      additionalInfoLoaded,
      translatedAdditionalInfoText,
      showOriginalAdditionalInfo,
      additionalInfoLoading
    } } = this.props;

    const descriptionData = {
      translatedRequired: translatedDescriptionRequired,
      loaded: descriptionLoaded,
      translatedText: translatedDescriptionText,
      showOriginal: showOriginalDescription,
      loading: descriptionLoading
    };
    const additionalInfoData = {
      translatedRequired: translatedAdditionalInfoRequired,
      loaded: additionalInfoLoaded,
      translatedText: translatedAdditionalInfoText,
      showOriginal: showOriginalAdditionalInfo,
      loading: additionalInfoLoading
    };

    return (
      <Company
        {...this.props}
        isNative={isNative}
        descriptionData={descriptionData}
        additionalInfoData={additionalInfoData}
        showMessageModal={this.state.showMessageModal}
        routeData={this.props.routeData}
        setPinAsReviewed={this.props.setPinAsReviewed}
        reviewedPins={this.props.reviewedPins}
        favoriteProperties={this.props.favoriteProperties.favoriteIDs}
        toggleFavorite={this.props.toggleFavorite}
        userToken={this.props.userToken}
      />
    );
  }
}

CompanyPage.propTypes = {
  locale: PropTypes.string,
  companyId: PropTypes.string.isRequired,
  error: PropTypes.object,
  company: PropTypes.object,
  reset: PropTypes.func,
  resetReduxForm: PropTypes.func,
  consultationReset: PropTypes.func,
  isMobile: PropTypes.bool,
  translate: PropTypes.func,
  routeData: PropTypes.object,
  openModalShare: PropTypes.func.isRequired,
  hideModalShare: PropTypes.func.isRequired,
  isModalShareOpen: PropTypes.bool.isRequired,
  setPinAsReviewed: PropTypes.func.isRequired,
  reviewedPins: PropTypes.array,
  favoriteProperties: PropTypes.object,
  toggleFavorite: PropTypes.func,
  userToken: PropTypes.string,
  loadFavorites: PropTypes.func,
  openLightbox: PropTypes.func,
  hideLightbox: PropTypes.func,
  changeLightboxActiveSlide: PropTypes.func,
  currentImage: PropTypes.number,
  isLightboxOpen: PropTypes.bool,
  isNative: PropTypes.bool,
  companyDetails: PropTypes.object,
  location: PropTypes.object.isRequired,
  openPopupWithDetails: PropTypes.func,
  overrideCurrency: PropTypes.string
};

CompanyPage.contextTypes = {
  router: PropTypes.object.isRequired
};

const asyncData = [{
  key: 'fetchCompanyData',
  promise: ({ params: { companyId }, store: { dispatch, getState } }) => {
    const { company, userAuthentication } = getState();
    const currentCompanyId = get(company, 'data.id');
    const loading = get(company, 'loading');
    const token = get(userAuthentication, 'accessToken') || get(userAuthentication, 'data.access_token');
    const companyOwnId = get(userAuthentication, 'data.agent_data.agency_id');
    const shouldLoad = (companyId && (companyId !== 'null') && (companyId !== currentCompanyId) && !loading);
    if (token && companyOwnId === companyId) {
      if (!loading && companyId !== 'null') {
        return dispatch(loadOwnCompany({ companyId, token }));
      }
    }

    return shouldLoad && dispatch(loadCompany({ id: companyId, token }));
  }
},
{
  key: 'fetchCompanyProps',
  promise: ({ params: { companyId }, store: { dispatch, getState } }) => {
    const { company } = getState();
    const currentCompanyId = get(company, 'data.id');
    const properties = get(company, 'properties');
    const loading = get(company, 'propertiesLoading');
    const shouldLoad = !loading && companyId && (companyId !== 'null') && (!properties || !properties.length || (companyId !== currentCompanyId));

    return shouldLoad && dispatch(loadCompanyProps(companyId));
  }
}];

const mapStateToProps = (store, { routeParams }) => {
  const routeData = extractRouteData(store.routing, store.lang.locale);

  return {
    locale: routeData.locale,
    isMobile: store.windowDimentions.isMobile,
    isNative: store.native.isNative,
    translate: getLang(store.lang, 'static'),
    companyId: routeParams.companyId,
    company: store.company.data || {},
    consultation: store.consultation.data,
    formConsultationError: store.consultation.formError,
    companyDetails: store.company || {},
    formConsultationSubmitted: store.consultation.formSubmitted,
    formConsultationSubmitting: store.consultation.formSubmitting,
    error: store.company.error,
    isLightboxOpen: store.propertyDetails.isLightboxOpen,
    currentImage: store.propertyDetails.currentImage,
    properties: store.company.properties,
    mobileCompanyContactIsOpen: store.company.mobileCompanyContactIsOpen,
    userId: store.userAuthentication.userIsAuthorized && store.userAuthentication.data.id,
    userToken: (store.userAuthentication.data) ? store.userAuthentication.data.access_token : null,
    formSubmitted: store.company.formSubmitted,
    formSubmitting: store.company.formSubmitting,
    formError: store.company.formError,
    isDetailsModalOpen: store.propertyDetails.isDetailsModalOpen,
    isModalShareOpen: store.shareModal.isModalShareOpen,
    reviewedPins: store.reviewedPins.reviewedIds,
    favoriteProperties: store.favoriteProperties,
    favouritePropertiesIDs: get(store, 'favoriteProperties.favoriteIDs', []),
    overrideCurrency: store.currency.currency
  };
};

const mapDispatchToProps = {
  loadCompany,
  loadOwnCompany,
  loadCompanyProps,
  openCompanyContactModal,
  closeCompanyContactModal,
  sendCompanyContactUsForm,
  openMessageModal,
  hideMessageModal,
  reset,
  resetReduxForm,
  consultationReset,
  sendConsultationForm,
  openModalShare,
  hideModalShare,
  setPinAsReviewed,
  toggleFavorite,
  loadFavorites,
  openLightbox,
  hideLightbox,
  changeLightboxActiveSlide,
  translateDescription,
  translateAdditionalInfo,
  detectDescriptionLanguage,
  detectAdditionalInfoLanguage,
  toggleDescriptionTranslation,
  toggleAdditionalInfoTranslation,
  resetTranslate
};

export default compose(
  asyncConnect(asyncData),
  connect(mapStateToProps, mapDispatchToProps)
)(withDetailsPopupPage(withPageWrapper(CompanyPage)));
